import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { url, request } from '../../../../config';
import { Autocomplete, Box, TextField } from '@mui/material';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import transferConfirmation from './../../img/transfer-confirmation.svg';
import InputMask from 'react-input-mask';
import { getFormatedDate } from '../../../../helpers/fotmatDate';
import Loading from '../../Loading/Loading';

class Create extends Component {
    state = {
        open: false,
        submit: false,
        step: 1,
        fromName: "",
        fromAddress: "",
        fromTax: "",
        fromPhoneNumber: "",
        toName: "",
        toPin: "",
        toPhoneNumber: "",
        description: "",
        descriptionId: null,
        orderCount: "",
        totalAmount: "",
        fee: "",
        descriptions: [],
        readOnly: false,
        statusName: '',
        rejectNote: '',
        amount: '',
        feeAmount: '',
        dataDate: null,
        invoiceNumber: '',
        expiredDate: null,
        id: null,
        isLoading: false
    }

    getData = () => {
        this.setState({ isLoading: true });
        let getDataRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("invoice/getData", getDataRequestBody))
            .then(res => res.text())
            .then((getDataResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getDataResponse = JSON.parse(getDataResponseJSON);
                if (getDataResponse.status.statusCode !== 1) {
                    if (getDataResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getDataResponse.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    const phoneFromStorage = localStorage.getItem('phoneNumber');
                    this.setState(
                        {
                        ...getDataResponse,
                        fromPhoneNumber: phoneFromStorage
                        },
                        () => {
                            if (this.props.match.params.id) {
                                this.getInvoiceById(this.props.match.params.id);
                            } else {
                                this.setState({ isLoading: false });
                            }
                        }
                    );
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getInvoiceById = (id) => {
        let getInvoiceByIdRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request("invoice/getInvoiceById", getInvoiceByIdRequestBody))
            .then(res => res.text())
            .then((getInvoiceByIdResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getInvoiceByIdResponse = JSON.parse(getInvoiceByIdResponseJSON);
                if (getInvoiceByIdResponse.status.statusCode !== 1) {
                    if (getInvoiceByIdResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getInvoiceByIdResponse.status.statusCode));
                        this.setState({ isLoading: false });
                    }
                }
                else {
                    this.setState({ ...getInvoiceByIdResponse.invoice, readOnly: this.props.location.pathname.split('/')[4] !== 'edit', isLoading: false })
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    check = (e) => {
        e.preventDefault();
        this.setState({ submit: true });
        let { toName, toPin, description, orderCount, totalAmount, step } = this.state;
        const isFormValid =
            toName &&
            toPin &&
            orderCount &&
            totalAmount &&
            description &&
            description.length >= 3 &&
            description.length <= 50;

            if (isFormValid) {
            step === 2 ? this.create(e) : this.getCommission(e)
        }
    }

    getCommission = (e) => {
        e.preventDefault();
        let { totalAmount, description } = this.state;
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let createRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            totalAmount, description
        }
        fetch(request("invoice/getCommission", createRequestBody, "POST"))
            .then(res => res.text())
            .then((createResponseJSON) => {
                const JSON = require('true-json-bigint');
                let createResponse = JSON.parse(createResponseJSON);
                if (createResponse.status.statusCode !== 1) {
                    if (createResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ fee: createResponse.fee, step: 2 })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    create = (e) => {
        e.preventDefault();
        let { toName, toPin, toPhoneNumber, fromPhoneNumber, description, orderCount, totalAmount, id } = this.state;
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let createRequestBody = {
            toName, toPin, toPhoneNumber, fromPhoneNumber, description, orderCount, totalAmount,
            invoiceId: id,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        }
        fetch(request(`invoice/${id ? "updateInvoice" : "createInvoice"}`, createRequestBody, "POST"))
            .then(res => res.text())
            .then((createResponseJSON) => {
                const JSON = require('true-json-bigint');
                let createResponse = JSON.parse(createResponseJSON);
                if (createResponse.status.statusCode !== 1) {
                    if (createResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(createResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(createResponse.status.statusCode), null, null, () => this.props.history.push('/dashboard/finance/invoices/list'));
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        this.getData();
    }

    render() {
        let { t } = this.props;
        let { submit, step, fromName, fromAddress, fromTax, fromPhoneNumber, toName, toPin, toPhoneNumber, description, orderCount,
            totalAmount, fee, readOnly, statusName, rejectNote, amount, feeAmount, dataDate, invoiceNumber, expiredDate, id, isLoading } = this.state;
        return (
            <Fragment>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3051C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.30512 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{id ? t('Invoice') : t('New invoice')}</h2>
                    </div>
                </div>
                <div className="dashboard-payment-container">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-contact-section py-4">
                            {isLoading ? <Loading /> :
                                <form onSubmit={(e) => this.check(e)} className="dashboard-account-container-component dashboard-contact-section-form align-items-end" >
                                    <Box className='dashboard-account-container-component-block invoice'>
                                        <TextField variant="outlined" sx={{ width: 305 }} label={t('Last payment date')} value={getFormatedDate(expiredDate, "dd.mm.yyyy")} InputProps={{ readOnly: true }} />
                                        {id && <>
                                            <TextField variant="outlined" sx={{ width: 305 }} label={t('date')} value={getFormatedDate(dataDate, "dd.mm.yyyy")} InputProps={{ readOnly: true }} />
                                            <TextField variant="outlined" sx={{ width: 305 }} label={t('Invoice number')} value={invoiceNumber} InputProps={{ readOnly: true }} />
                                            <TextField variant="outlined" sx={{ width: 305 }} label={t('Status')} value={statusName} InputProps={{ readOnly: true }} />
                                            {rejectNote && <TextField variant="outlined" sx={{ width: 305 }} label={t('Reason for rejection')} value={rejectNote} InputProps={{ readOnly: true }} />}
                                        </>}
                                    </Box>
                                    <h6 className='w-100 mb-0 mt-3'>{t('Entrepreneur information')}</h6>
                                    <Box className='dashboard-account-container-component-block invoice'>
                                        <TextField variant="outlined" sx={{ width: 305 }} label={t('name')} value={fromName} InputProps={{ readOnly: true }} />
                                        <TextField variant="outlined" sx={{ width: 305 }} label={t('tin')} value={fromTax} InputProps={{ readOnly: true }} />
                                        <InputMask value={fromPhoneNumber} mask="+\9\9\4 ( 99 ) 999-99-99" placeholder="+994 (__) ___-__-__" readOnly={readOnly}
                                            onChange={(e) => this.setState({ fromPhoneNumber: e.target.value.replace(/[^\d+]/g, "") })}>
                                            {() => <TextField variant="outlined" sx={{ width: 305 }} label={t('Contact number')}
                                                InputProps={{ endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />}
                                        </InputMask>
                                        <TextField variant="outlined" sx={{ width: 305 }} label={t('Address')} value={fromAddress} InputProps={{ readOnly: true }} />
                                        {readOnly && <TextField variant="outlined" sx={{ width: 305 }} label={t('Amount to be paid')} value={amount} InputProps={{ readOnly: true }} />}
                                        {readOnly && <TextField variant="outlined" sx={{ width: 305 }} label={t('Commission')} value={feeAmount} InputProps={{ readOnly: true }} />}
                                    </Box>

                                    <h6 className='w-100 mb-0 mt-3'>{t('Buyers information')}</h6>
                                    <Box className='dashboard-account-container-component-block invoice'>
                                        <TextField variant="outlined" sx={{ width: 305 }} error={!toName && submit} label={t('First name, Last name, Patronymic')} value={toName} onChange={(e) => this.setState({ toName: e.target.value.replace(/[^\p{L}\s]/gu, "").replace(/(^|\s)(\p{L})/gu, (_, space, letter) => space + letter.toUpperCase()) })}
                                            InputProps={{ readOnly: readOnly, endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                        <TextField variant="outlined" sx={{ width: 305 }} inputProps={{ maxLength: 7 }} error={!toPin && submit} label={t('Pin code')} value={toPin} onChange={(e) => this.setState({ toPin: e.target.value.replace(/[^A-Za-z0-9]/g, "").toUpperCase() })}
                                            InputProps={{ readOnly: readOnly, endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                        <InputMask value={toPhoneNumber} mask="+\9\9\4 ( 99 ) 999-99-99" placeholder="+994 (__) ___-__-__" readOnly={readOnly}
                                            onChange={(e) => this.setState({ toPhoneNumber: e.target.value.replace(/[^\d+]/g, "") })}>
                                            {() => <TextField variant="outlined" sx={{ width: 305 }} label={t('Contact number')}
                                                InputProps={{ endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />}
                                        </InputMask>
                                        {readOnly && <TextField variant="outlined" sx={{ width: 305 }} label={t('Amount to be paid')} value={totalAmount} InputProps={{ readOnly: true }} />}
                                    </Box>

                                    <h6 className='w-100 mb-0 mt-3'>{t('Products and services')}</h6>
                                    <Box className='dashboard-account-container-component-block invoice'>
                                        {/* <Autocomplete
                                            sx={{ width: 305 }}
                                            readOnly={readOnly}
                                            options={descriptions}
                                            getOptionLabel={option => option.name}
                                            value={descriptions.find(item => item.id == descriptionId) || null}
                                            onChange={(event, newValue) => this.setState({ descriptionId: newValue?.id })}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                error={!descriptionId && submit}
                                                placeholder={t('Choose')}
                                                label={t('Description')}
                                            />} /> */}

                                            <form noValidate>
                                                <TextField
                                                    variant="outlined"
                                                    sx={{ width: 305 }}
                                                    label={t('Description')}
                                                    value={description || ''}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length <= 50) {
                                                            this.setState({ description: value });
                                                        }
                                                    }}
                                                    InputProps={{ readOnly }}
                                                    error={submit && description?.length < 3}
                                                    helperText={
                                                        submit && description?.length < 3
                                                            ? t('descriptionMinMax')
                                                            : t('descriptionCounter', {
                                                                count: description?.length || 0,
                                                                max: 50
                                                            })
                                                    }
                                                />
                                            </form>

                                        <TextField variant="outlined" sx={{ width: 305 }} inputProps={{ maxLength: 15 }} error={!orderCount && submit} label={t('Count')} value={orderCount} onChange={(e) => this.setState({ orderCount: e.target.value.replace(/\D/g, "") })}
                                            InputProps={{ readOnly: readOnly, endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />
                                        {!readOnly && <TextField variant="outlined" sx={{ width: 305 }} inputProps={{ maxLength: 15 }} error={!totalAmount && submit} label={t('Amount')} value={totalAmount} onChange={(e) => this.setState({ totalAmount: e.target.value.replace(/^(\d+(\.\d{0,2})?)?.*$/, '$1'), step: 1, fee: '' })}
                                            InputProps={{ endAdornment: !readOnly && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M11.3333 2C11.5083 1.8249 11.7162 1.68601 11.945 1.59125C12.1738 1.49649 12.419 1.44772 12.6666 1.44772C12.9142 1.44772 13.1594 1.49649 13.3882 1.59125C13.617 1.68601 13.8248 1.8249 13.9999 2C14.175 2.1751 14.3139 2.38297 14.4087 2.61174C14.5034 2.84051 14.5522 3.08571 14.5522 3.33333C14.5522 3.58096 14.5034 3.82615 14.4087 4.05493C14.3139 4.2837 14.175 4.49157 13.9999 4.66667L4.99992 13.6667L1.33325 14.6667L2.33325 11L11.3333 2Z" stroke="#1E1E1E" stroke-linecap="round" stroke-linejoin="round" /></svg> }} />}
                                        <TextField variant="outlined" sx={{ width: 305 }} label={t('currency')} value="AZN" InputProps={{ readOnly: true }} />
                                        {fee && !readOnly && <TextField variant="outlined" sx={{ width: 305 }} label={`${t('Commission')} (1%)`} value={fee} InputProps={{ readOnly: true }} />}
                                    </Box>
                                    {!readOnly &&
                                        <div className="dashboard-payment-container-data-section-content-container-form-footer d-flex justify-content-end">
                                            <button type='submit' className="dashboard-contact-section-button">{step === 2 ? t('continue') : t('Calculate commission')}</button>
                                        </div>}
                                </form>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Invoice services')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('invoice text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default translate("translation")(Create);